<template>
  <div class="table_box">
    <el-table
      ref="tableRef"
      :summary-method="getSummaries"
      show-summary
      size="small"
      :data="data"
      border
      style="width:100%"
      :height="max"
      class="tabone_sty"
      @row-dblclick="rowdblclick"
      :header-cell-style="{background:'#eef1f6',color:'#000',fontSize:'16px',height:'40px'}"
    >
      <el-table-column width="40" align="center" fixed="left">
        <template slot="header" slot-scope="scope">
          <i
            :class="isInner?'el-icon-s-tools':'el-icon-refresh-left'"
            style="color:#2594ff;font-size:18px"
            @click="clickIcon"
          ></i>
        </template>
        <template slot-scope="scope">{{scope.$index +1 }}</template>
      </el-table-column>
      <el-table-column fixed="left" label="操作" align="center" width="80">
        <template slot-scope="scope">
          <el-button
            @click.native.prevent="detailRow(scope.$index,scope.row)"
            type="text"
            size="small"
          >明细</el-button>
          <!-- <el-button @click.native.prevent="distributionRow(scope.$index)" type="text" size="small">客户分布</el-button> -->
        </template>
      </el-table-column>
      <el-table-column label="类型" align="center" width="120">
        <template slot-scope="scope">
          <i
            :class="scope.row.IsDir?'el-icon-folder':'el-icon-tickets'"
            style="color:#e9cb70;font-size:18px"
          ></i>
        </template>
      </el-table-column>
      <template v-for="(item,index) in ConfigData">
        <el-table-column
          v-if="item.Show == true"
          :label="item.Rename"
          :prop="item.Key"
          width="120"
          align="center"
          :key="index"
        >
          <template slot-scope="scope">
            <span>{{scope.row[item.Key]}}</span>
          </template>
        </el-table-column>
      </template>
    </el-table>
    <!-- table表格配置弹出框 -->
    <TableConfigDialog
      :show.sync="tableConfigShow"
      :tableData="ConfigData"
      v-bind="$attrs"
      v-on="$listeners"
      @restoreDefault="restoreDefault"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      value: false, //是否启用扫码枪录入商品
      tableConfigShow: false, //配置项弹出框是否显示
      ConfigData: this.tableConfigData, //table配置项数据
      rowIndex: -1, //点击的是第几行
      data: this.tableData, //表格数据项
      // jparam:this.goodsParams,
      searchData: { title: "", data: {}, type: "" }, //传递给选择单价与单位的弹出框,title:弹出框标题、data：传过去的数据、type：类型（单价选择、单位选择）
      isInner: true,
    };
  },
  props: {
    max: String,
    tableData: Array,
    tableConfigData: Array, //table配置项数据
  },
  methods: {
    // 点击明细
    detailRow(index, data) {
      if (this.$attrs.pargam.Model == "SaleStats") {
        // dist:0为普通页面跳转过来的，1为统计跳过来的
        let item = {
          title: "商品销售明细",
          component: "goodssaledetail",
          menuId: "goodsSaleDetail" + "detailRow" + Math.random(),
          query: {},
        };
        this.$tab.push(item, {
          data: data,
          dist: 1,
        });
      } else {
        // dist:0为普通页面跳转过来的，1为统计跳过来的
        let item = {
          title: "商品采购明细",
          component: "goodsbuydetail",
          menuId: "goodsBuyDetail" + "detailRow" + Math.random(),
          query: {},
        };
        this.$tab.push(item, {
          data: data,
          dist: 1,
        });
      }
    },
    // 聚焦选中input全部
    inputFocus() {
      event.currentTarget.select();
    },
    // 双击表格某一行
    rowdblclick(row) {
      if (row.IsDir) {
        this.isInner = false;
        this.$emit("rowdblclick", row);
      } else {
        // 跳转页面
      }
    },
    //合计方法
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "总计";
          return;
        }
        const values = data.map((item) => {
          // if (
          //   column.property == "InPurchaseQty" ||
          //   column.property == "InPurchaseTotal" ||
          //   column.property == "NetPurchaseQuantity" ||
          //   column.property == "NetPurchaseAmount"||
          //   column.property == "SaleCostTotal"||//销售成本金额

          //   column.property == "OutPurchaseQty"||//退货数量
          //   column.property == "OutPurchaseTotal"||//退货金额
          //   column.property == "OutPurchaseCostTotal"//退货成金额
          // ) {
          // if (Number(item[column.property]) != "undefined") {
          return this.$attrs.footerMet[column.property];
          // }
          // }
        });
        if (!values.every((value) => isNaN(value))) {
          sums[index] = this.$attrs.footerMet[column.property];
          sums[index] += "";
        } else {
          // sums[index] = 'N/A';
        }
      });
      return sums;
    },
    // 累加数组中的number
    sum(arr) {
      var s = 0;
      for (var i = arr.length - 1; i >= 0; i--) {
        s += arr[i];
      }
      return Number(s).toFixed(2);
    },
    //点击图标事件
    clickIcon() {
      if (!this.isInner) {
        this.isInner = true;
        this.$emit("clickIcon");
      } else {
        this.tableConfigShow = true;
      }
    },
    // 恢复默认回调数据
    restoreDefault(data) {
      this.ConfigData = data;
    },
  },
  watch: {
    Obtain: {
      handler(newValue, oldValue) {
        this.ObtainHeader = newValue;
      },
      deep: true,
      immediate: true,
    },
    tableConfigData: {
      handler(newValue, oldValue) {
        this.ConfigData = newValue;
        this.data = this.tableData;
        this.$nextTick(() => {
          this.$refs.tableRef.doLayout();
        });
      },
      deep: true,
    },
    tableData: {
      handler(newValue, oldValue) {
        this.data = this.tableData;
        this.$nextTick(() => {
          this.$refs.tableRef.doLayout();
        });
        setTimeout(() => {
          this.$refs.tableRef.recalculate(); // 表格计算
          this.$refs.tableRef.updateData(); // 表格刷新
          this.$refs.tableRef.doLayout();
        }, 500);
      },
      deep: true,
    },
  },
  computed: {},
  mounted() {},
};
</script>
<style lang="less">
// 引入样式
@import "./StatisticTable.less";
</style>


// WEBPACK FOOTER //
// src/components/Table/StatisticTable/StatisticTable.vue